import { css } from 'linaria';
import { theme } from '../../Theme';

// Use linaria css to style the component.
// All styling should be placed in :global().
// Begin all styling with root class name of component.

css`
  :global() {
    .hero {
      position: relative;
      width: 100%;
      max-width: ${theme.layout.maxWidth};

      &.fullWidth {
        max-width: 100%;
      }
    }
  }
`;
